import { render, staticRenderFns } from "./how-it-works.vue?vue&type=template&id=351d414e"
import script from "./how-it-works.vue?vue&type=script&lang=js"
export * from "./how-it-works.vue?vue&type=script&lang=js"
import style0 from "./how-it-works.vue?vue&type=style&index=0&id=351d414e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports